import angular from 'angular';

const dependencies = ['Sq.Vendor', 'Sq.Flux', 'Sq.Core.Configuration', 'Sq.Core.StateSynchronizer'];

angular.module('Sq.Core', dependencies);
